import React, {useEffect, useState} from 'react';
import api from "../../api";
import {ToastContainer} from "react-toastify";
import moment from 'moment-jalaali';
import {e2p, formatNumber} from "../../utils/utils";
import {Link, useParams} from "react-router-dom";

function AdminTransaction() {
    const [transactions, setTransactions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [filters, setFilters] = useState({user_id: '', status: '', date_from: '', date_to: ''});
    const [pagination, setPagination] = useState({current_page: 1, per_page: 20, total: 0});

    function fetchTransactions() {
        setIsLoading(true);

        const queryParams = {
            ...filters,
            page: pagination.current_page,
            per_page: pagination.per_page,
        };

        api.get('/wallet/admin/transactions', {params: queryParams})
            .then(response => {
                const {data, pagination} = response.data;
                setTransactions(data);
                setPagination(prev => ({
                    ...prev,
                    total: pagination.total,
                    current_page: pagination.current_page,
                }));
            })
            .catch(error => {
                console.error('Error fetching transactions: ', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    useEffect(() => {
        fetchTransactions();
    }, [filters, pagination.current_page]);

    function handleFilterChange(e) {
        const {name, value} = e.target;
        setFilters(prev => ({...prev, [name]: value}));
    }

    function handlePageChange(newPage) {
        setPagination(prev => ({...prev, current_page: newPage}));
    }

    return (
        <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="card border-3 rounded-4 border-dark mb-4">
                            <div className="card-header bg-dark text-center">
                                <h4 className="m-0 text-white text-center">لیست همه‌ی تراکنش‌ها</h4>
                            </div>
                            <div className="card-body">
                                {/* Filters */}
                                <div className="row mb-3">
                                    {/*<div className="col-md-3">*/}
                                    {/*    <input*/}
                                    {/*        type="text"*/}
                                    {/*        name="user_id"*/}
                                    {/*        placeholder="شناسه کاربر"*/}
                                    {/*        value={filters.user_id}*/}
                                    {/*        onChange={handleFilterChange}*/}
                                    {/*        className="form-control"*/}
                                    {/*    />*/}
                                    {/*</div>*/}
                                    <div className="col-md-3">
                                        <select
                                            name="status"
                                            value={filters.status}
                                            onChange={handleFilterChange}
                                            className="form-control"
                                        >
                                            <option value="">همه وضعیت‌ها</option>
                                            <option value="completed">پرداخت شده</option>
                                            <option value="pending">در انتظار پرداخت</option>
                                        </select>
                                    </div>
                                    {/*<div className="col-md-3">*/}
                                    {/*    <input*/}
                                    {/*        type="date"*/}
                                    {/*        name="date_from"*/}
                                    {/*        value={filters.date_from}*/}
                                    {/*        onChange={handleFilterChange}*/}
                                    {/*        className="form-control"*/}
                                    {/*    />*/}
                                    {/*</div>*/}
                                    {/*<div className="col-md-3">*/}
                                    {/*    <input*/}
                                    {/*        type="date"*/}
                                    {/*        name="date_to"*/}
                                    {/*        value={filters.date_to}*/}
                                    {/*        onChange={handleFilterChange}*/}
                                    {/*        className="form-control"*/}
                                    {/*    />*/}
                                    {/*</div>*/}
                                </div>

                                {/* Table */}
                                <div className='table-responsive'>
                                    <table className="table table-hover table-bordered table-rounded">
                                        <thead>
                                        <tr className="text-center shadow pb-4"
                                            style={{backgroundColor: 'var(--header-color)'}}>
                                            <th>نام صافکاری</th>
                                            <th>تلفن</th>
                                            <th>مبلغ</th>
                                            <th>توضیحات</th>
                                            <th>نوع تراکنش</th>
                                            <th>وضعیت تراکنش</th>
                                            <th>تاریخ</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            transactions.map((transaction, index) => (
                                                <tr
                                                    key={index}
                                                    className={`${transaction.type === 'charge' ? (
                                                        transaction.status === 'pending' ? 'table-warning' : 'table-success'
                                                    ) : 'table-danger'}`}
                                                >
                                                    <td className="text-center">
                                                        <Link to={`/admin/transactions/${transaction.company.id}`}>
                                                            {transaction.company.company}
                                                        </Link>
                                                    </td>
                                                    <th className="text-center">
                                                        <a href={`tel:${transaction.company.phone_number}`}>
                                                            {transaction.company.phone_number}
                                                        </a>
                                                    </th>
                                                    <td className="text-center">{e2p(formatNumber(transaction.amount))} ریال</td>
                                                    <td className="text-center">{transaction.description}</td>
                                                    <td className="text-center">
                                                        {transaction.type === 'charge' ? 'شارژ' : 'کسر'}
                                                    </td>
                                                    <td className="text-center">
                                                        {transaction.type === 'charge' ? (
                                                            <p className="m-0 text-center">
                                                                {transaction.status === 'pending'
                                                                    ? 'در انتظار پرداخت'
                                                                    : transaction.status === 'completed'
                                                                        ? 'پرداخت شده' : ''}
                                                            </p>
                                                        ) : (
                                                            <p className="m-0 text-center">کسر شده</p>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        {e2p(
                                                            moment(transaction.created_at)
                                                                .locale('fa')
                                                                .format('jYYYY/jMM/jDD HH:mm')
                                                        ).replace(' - ', ' ')}
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                <div className="d-flex justify-content-between mt-3">
                                    <button
                                        className="btn btn-dark"
                                        disabled={pagination.current_page === 1}
                                        onClick={() => handlePageChange(pagination.current_page - 1)}
                                    >
                                        صفحه قبل
                                    </button>
                                    <button
                                        className="btn btn-dark"
                                        disabled={pagination.current_page === Math.ceil(pagination.total / pagination.per_page)}
                                        onClick={() => handlePageChange(pagination.current_page + 1)}
                                    >
                                        صفحه بعد
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminTransaction;
